import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CardWrapper = styled.div<{ width: number }>`
    width: ${(props) => props.width}px;
    height: auto;
    display: flex;
    flex-direction: column;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};
    overflow: hidden;
`;

export const CardImage = styled(LazyLoadImage)<{ isCover: boolean }>`
    width: 100%;
    height: 134px;
    border-radius: ${BorderRadius.OuterBlockRadius} ${BorderRadius.OuterBlockRadius} 0 0;
    background-repeat: no-repeat;
    background-position: center;
    object-fit: ${(props) => props.isCover ? 'cover' : 'contain'};
    background-color: ${COLORS.BgMain};
`;

export const CardContent = styled.div`
    width: 100%;
    padding: 12px 24px;
    display: flex;
    flex-direction: column;
`;

export const CardTitle = styled.div`
    ${FONTS.H4};
    color: ${COLORS.TextPrimary};
    margin-bottom: 8px;
`;

export const CardDescription = styled.div`
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};
`;
